import { useEffect } from 'react';

/**
 * Custom hook to set page title for SEO
 * @param {string} title - The page-specific title (will be followed by " | StoryWeaver")
 * @param {string} description - Optional meta description for the page
 */
export const usePageTitle = (title, description = null) => {
  useEffect(() => {
    // Set the document title
    document.title = title ? `${title} | StoryWeaver` : 'StoryWeaver - AI Storybook Creator for Kids';
    
    // Update meta description if provided
    if (description) {
      let metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute('content', description);
      }
    }
    
    // Cleanup - reset to default when component unmounts
    return () => {
      document.title = 'StoryWeaver - AI Storybook Creator for Kids';
    };
  }, [title, description]);
};

export default usePageTitle;
